import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WarningDialogComponent } from '../warning-dialog/warning-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ResetConfirmDialogComponent } from '../reset-confirm-dialog/reset-confirm-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class CvDialogService {
    constructor(
        private modalService: NgbModal
    ) { }

    showConfirmDialog(title: string, prompt: string, isCXOne: boolean, okCallback = this.noop, cancelCallback = this.noop) {
        const modalRef = this.modalService.open(ConfirmDialogComponent, { centered: true });
        const instance: ConfirmDialogComponent = modalRef.componentInstance;
        instance.title = title;
        instance.prompt = prompt;
        instance.isCXone = isCXOne;
        modalRef.result.then(okCallback, cancelCallback);
        return modalRef;
    }

    showWarningDialog(title: string, prompt: string, okCallback = this.noop) {
        const modalRef = this.modalService.open(WarningDialogComponent);
        const instance: WarningDialogComponent = modalRef.componentInstance;
        instance.title = title;
        instance.prompt = prompt;
        modalRef.result.then(okCallback, okCallback);
        return modalRef;
    }

    showResetConfirmDialog(title: string, prompt: string, isCXOne: boolean, okCallback = this.noop, cancelCallback = this.noop) {
        const modalRef = this.modalService.open(ResetConfirmDialogComponent, { centered: true });
        const instance: ResetConfirmDialogComponent = modalRef.componentInstance;
        instance.title = title;
        instance.prompt = prompt;
        instance.isCXone = isCXOne;
        modalRef.result.then(okCallback, cancelCallback);
        return modalRef;
    }

    private noop = () => {};
}
